const schema = (vehicleTypes, vehicleStatuses, isSuperAdmin) => {
  const properties = {
    plaque: {
      type: 'string',
      title: 'plaque',
    },
  };

  if (isSuperAdmin) {
    properties.owner_ids = {
      type: 'string',
      title: 'owner',
    };
    properties.type_ids = {
      type: 'string',
      title: 'vehicle_type',
      default: undefined,
      oneOf: vehicleTypes,
    };
  }

  return {
    type: 'object',
    required: [],
    properties,
  };
};

export default schema;
